import Cookies from 'js-cookie'
import { handleActions } from 'redux-actions'

import {
  setAuthenticationState,
  setDefaultClinicianCalendar,
  setIsUrgentCareUser,
  setReloadPage,
  setRememberPasswordExpiration,
  setRibbonTimestamp,
  setShouldShowPasswordExpired,
  setUserActivitiesCounters,
  setUserDataLoadedState,
  setUserLicenseModule,
  setUserProfile,
  setUserRoles
} from 'src/store/modules/user/actionCreators'

const initialState = {
  isAuthenticated: Boolean(
    Cookies.get('access_token') || Cookies.get('refresh_token')
  ),
  isRequiredUserDataLoaded: false,
  isManuallyLoggedOut: false,
  profile: {
    caseManagerNotifications: [],
    gridSettings: {}
  },
  roles: {},
  isTeleMedicineBillable: false,
  isUrgentCareUser: false,
  rememberPasswordExpiration: null,
  shouldShowPasswordExpired: true,
  ribbonTimestamp: 0,
  userActivitiesCounters: {},
  reloadPage: false
}

export default handleActions(
  {
    [setAuthenticationState](state, { payload }) {
      return {
        ...state,
        ...payload
      }
    },

    [setUserProfile](state, { payload }) {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...payload
        }
      }
    },

    [setDefaultClinicianCalendar](state, { payload }) {
      return {
        ...state,
        profile: {
          ...state.profile,
          defaultClinicianCalendar: payload
        }
      }
    },

    [setUserDataLoadedState](state, { payload }) {
      return {
        ...state,
        isRequiredUserDataLoaded: payload
      }
    },

    [setUserLicenseModule](state, { payload = [] }) {
      return {
        ...state,
        profile: {
          ...state.profile,
          licenseModule: payload
        }
      }
    },

    [setUserRoles](state, { payload: roles }) {
      return {
        ...state,
        roles
      }
    },

    [setReloadPage](state, { payload: reloadPage }) {
      return {
        ...state,
        reloadPage
      }
    },

    [setIsUrgentCareUser](state, { payload: isUrgentCareUser }) {
      return {
        ...state,
        isUrgentCareUser
      }
    },

    [setRememberPasswordExpiration](
      state,
      { payload: rememberPasswordExpiration }
    ) {
      return {
        ...state,
        rememberPasswordExpiration
      }
    },

    [setShouldShowPasswordExpired](
      state,
      { payload: shouldShowPasswordExpired }
    ) {
      return {
        ...state,
        shouldShowPasswordExpired
      }
    },

    [setRibbonTimestamp](state, { payload: ribbonTimestamp }) {
      return {
        ...state,
        ribbonTimestamp
      }
    },

    [setUserActivitiesCounters](state, { payload: userActivitiesCounters }) {
      return {
        ...state,
        userActivitiesCounters
      }
    }
  },
  initialState
)
